import {  trigger, state, style, transition, animate  } from '@angular/animations';
import { Component, Output, Input, EventEmitter,Inject } from '@angular/core';
import { User } from '../../../shared/entities/user';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';

declare var require: any;

@Component({
    selector: 'change-password',
    template: require('./change-password.component.html'),
})

export class ChangePasswordDialogComponent {
    
    constructor(public authenticationService:AuthenticationService,
                public snackBar:MatSnackBar,
                public dialogRef: MatDialogRef<ChangePasswordDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) { }

    private onClickRenovarSenhaEvent(newPassword:string, confirmPassword:string) {
        if (newPassword && newPassword == confirmPassword) {
            this.data.user.password = newPassword;
            this.changePassword(this.data.user);
        }
        else {
            this.openSnackBar('Não foi possível renovar a senha. As senhas digitadas são diferentes, verifique e tente novamente.', true);
            
        }
    }
       
    
    private changePassword(user:User) {
        this.authenticationService.changePassword(user).subscribe(
            result => { 
                this.dialogRef.close(true);
                this.openSnackBar('Sua senha foi alterada com sucesso!', false);
            },
            error =>  {
                this.openSnackBar('Não foi possível alterar sua senha, tente novamente. Caso o problema persista entre em contato com o administrador.', false);
            });
    }

    private onClickCloseUserDetailEvent() {
        this.dialogRef.close(true);
    }

    openSnackBar(msg:string, isError:boolean) {
        if (isError) {
            this.snackBar.open(msg, null, { duration: 2500, panelClass: 'snackbar-panel-error' });
        } else {
            this.snackBar.open(msg, null, {
                duration: 3500,
            });
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/core/components/change-password/change-password.component.ts